(() => {
  const STORAGE_KEY = 'mw-session-wishlist-v1';
  const enableProductHearts = /\/(?:products|collections)\/[^/]+/.test(location.pathname);
  const productPath = /\/products\/([^/?#]+)/;

  const read = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  };

  const write = (items) => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    sync();
  };

  const normalizeUrl = (url) => {
    try {
      const parsed = new URL(url, location.origin);
      const match = parsed.pathname.match(productPath);
      return match ? `/products/${match[1]}` : parsed.pathname;
    } catch (_) {
      return url;
    }
  };

  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const heart = (filled = false) => `
    <svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" ${filled ? 'fill="currentColor"' : 'fill="none"'} stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  const cleanPrice = (value) => {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    const euroPrices = text.match(/(?:€\s*\d[\d.]*,\d{2}|\d[\d.]*,\d{2}\s*€)/g);
    if (euroPrices?.length) return euroPrices.at(-1).replace(/€\s+/, '€').replace(/\s+€/, ' €');
    const apiPrice = text.match(/(\d+)\.(\d{2})\s+EUR/i);
    return apiPrice ? `€${Number(apiPrice[1]).toLocaleString('de-DE')},${apiPrice[2]}` : '';
  };

  const getCurrentCardPrice = (card) => {
    const selectors = [
      '.product-price--sale:not(.hidden) .price--sale-price',
      '.product-price--regular:not(.hidden) .price--regular-price',
      '.product-card-basic__price .price--sale-price',
      '.product-card-basic__price .price--regular-price',
    ];
    for (const selector of selectors) {
      const node = card.querySelector(selector);
      if (node) return cleanPrice(node.textContent);
    }
    return cleanPrice(card.querySelector('.product-grid--price, .product-card-basic__price')?.textContent);
  };

  const getCardData = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const url = normalizeUrl(link.href);
    const titleNode = card.querySelector('.product-grid--title a, .product-card-basic__title a, [data-product-card-link][title]');
    const image = card.querySelector('.grid-view-item-image img, .product-card-basic__image img, img');
    return {
      url,
      title: (titleNode?.textContent?.trim() || titleNode?.getAttribute('title')?.trim() || link.title?.trim() || image?.alt?.trim() || 'Produkt'),
      image: image?.currentSrc || image?.src || '',
      price: getCurrentCardPrice(card),
    };
  };

  const toggle = (item) => {
    const items = read();
    const index = items.findIndex((saved) => saved.url === item.url);
    if (index >= 0) items.splice(index, 1);
    else items.push(item);
    write(items);
  };

  const makeButton = (item, className = '') => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `mw-wishlist-toggle ${className}`.trim();
    button.dataset.mwWishlistUrl = item.url;
    button.setAttribute('aria-label', 'Zur Wunschliste hinzufügen');
    button.innerHTML = heart(false);
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggle(item);
    });
    return button;
  };

  const enhanceCards = () => {
    document.querySelectorAll('product-card, .product-card-basic').forEach((card) => {
      if (card.dataset.mwWishlistReady === 'true' || card.closest('#MwWishlistDialog')) return;
      const item = getCardData(card);
      const imageArea = card.querySelector('.grid-view-item-image, .product-card-basic__image');
      if (!item || !imageArea) return;
      card.dataset.mwWishlistReady = 'true';
      imageArea.classList.add('mw-wishlist-image-area');
      imageArea.append(makeButton(item, 'mw-wishlist-toggle--card'));
    });
  };

  const enhanceProductPage = () => {
    const type = document.querySelector('meta[property="og:type"]')?.content;
    if (type !== 'product' || document.querySelector('.mw-wishlist-toggle--product')) return;
    const canonical = document.querySelector('link[rel="canonical"]')?.href || location.href;
    const title = document.querySelector('meta[property="og:title"]')?.content || document.querySelector('h1')?.textContent || 'Produkt';
    const image = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]')?.content || '';
    const amount = document.querySelector('meta[property="product:price:amount"]')?.content || '';
    const currency = document.querySelector('meta[property="product:price:currency"]')?.content || '';
    const item = { url: normalizeUrl(canonical), title: title.trim(), image, price: amount ? `${amount} ${currency}`.trim() : '' };
    const titleNode = document.querySelector('.product-details-product-title, h1');
    if (!titleNode) return;
    const button = makeButton(item, 'mw-wishlist-toggle--product');
    button.insertAdjacentHTML('beforeend', '<span>Merken</span>');
    titleNode.insertAdjacentElement('afterend', button);
  };

  const renderDialog = () => {
    const dialog = document.querySelector('#MwWishlistDialog');
    const list = dialog?.querySelector('[data-mw-wishlist-list]');
    if (!dialog || !list) return;
    const items = read();
    if (!items.length) {
      list.innerHTML = '<p class="mw-wishlist-empty">Ihre Wunschliste ist noch leer.</p>';
      return;
    }
    list.innerHTML = items.map((item) => `
      <article class="mw-wishlist-item">
        <a href="${escapeHtml(item.url)}" class="mw-wishlist-item__image">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="160" height="160">` : ''}
        </a>
        <div class="mw-wishlist-item__content">
          <a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
          ${cleanPrice(item.price) ? `<span>${escapeHtml(cleanPrice(item.price))}</span>` : ''}
          <button type="button" data-mw-wishlist-remove="${escapeHtml(item.url)}">Entfernen</button>
        </div>
      </article>`).join('');
    list.querySelectorAll('[data-mw-wishlist-remove]').forEach((button) => {
      button.addEventListener('click', () => {
        write(read().filter((item) => item.url !== button.dataset.mwWishlistRemove));
        renderDialog();
      });
    });
  };

  const openDialog = () => {
    buildDialog();
    renderDialog();
    const dialog = document.querySelector('#MwWishlistDialog');
    if (typeof dialog?.showModal === 'function') dialog.showModal();
    else dialog?.setAttribute('open', '');
  };

  const buildDialog = () => {
    if (!document.querySelector('#MwWishlistDialog')) {
      document.body.insertAdjacentHTML('beforeend', `
        <dialog id="MwWishlistDialog" class="mw-wishlist-dialog" aria-labelledby="MwWishlistTitle">
          <div class="mw-wishlist-dialog__header">
            <h2 id="MwWishlistTitle">Meine Wunschliste</h2>
            <button type="button" data-mw-wishlist-close aria-label="Wunschliste schließen">×</button>
          </div>
          <div data-mw-wishlist-list></div>
        </dialog>`);
      const dialog = document.querySelector('#MwWishlistDialog');
      dialog.querySelector('[data-mw-wishlist-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

  };

  const buildUi = () => {
    if (!document.querySelector('[data-mw-wishlist-open]')) {
      const headerLinks = document.querySelector('.site-header__links.top-links--icon-links');
      if (headerLinks) {
        const item = document.createElement('li');
        item.innerHTML = `<button type="button" class="mw-wishlist-header" data-mw-wishlist-open aria-label="Wunschliste öffnen">${heart(false)}<span data-mw-wishlist-count>0</span></button>`;
        const cartItem = headerLinks.querySelector('.site-header__cart-toggle')?.closest('li');
        headerLinks.insertBefore(item, cartItem || headerLinks.firstChild);
        item.querySelector('button').addEventListener('click', openDialog);
      }
    }
  };

  const sync = () => {
    const items = read();
    const urls = new Set(items.map((item) => item.url));
    document.querySelectorAll('[data-mw-wishlist-url]').forEach((button) => {
      const active = urls.has(button.dataset.mwWishlistUrl);
      const state = active ? 'true' : 'false';
      if (button.dataset.mwWishlistActive === state) return;
      button.dataset.mwWishlistActive = state;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-label', active ? 'Von der Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
      const svg = button.querySelector('svg');
      if (svg) svg.outerHTML = heart(active);
    });
    document.querySelectorAll('[data-mw-wishlist-count]').forEach((count) => {
      const nextCount = String(items.length);
      if (count.textContent !== nextCount) count.textContent = nextCount;
      count.hidden = items.length === 0;
    });
  };

  const init = () => {
    buildUi();
    if (enableProductHearts) {
      enhanceCards();
      enhanceProductPage();
    }
    sync();
    if (!enableProductHearts) return;
    let queued = false;
    new MutationObserver((records) => {
      // Only newly inserted product cards need enhancement. Ignore our own UI.
      const hasNewCards = records.some((record) => Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 && !node.closest('#MwWishlistDialog') &&
        (node.matches('product-card, .product-card-basic') || node.querySelector('product-card, .product-card-basic'))
      ));
      if (!hasNewCards || queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        enhanceCards();
        sync();
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
